/**
 * #140: after a todo's document opens in the Reader, bring its passage into
 * view. The Reader has no in-document search, so this scrolls to the deepest
 * rendered element that contains the start of the passage and flashes it.
 */

const normalise = (text: string): string => text.replace(/\s+/g, ' ').trim();

const NEEDLE_LENGTH = 80;

export function locatePassage(
  passageText: string,
  container: ParentNode = window.document
): HTMLElement | null {
  const needle = normalise(passageText).slice(0, NEEDLE_LENGTH);
  if (!needle) return null;
  const scope = container.querySelector<HTMLElement>('#document-content');
  if (!scope) return null;

  const has = (element: Element): boolean =>
    normalise(element.textContent ?? '').includes(needle);
  let best: HTMLElement | null = has(scope) ? scope : null;
  while (best) {
    const deeper: HTMLElement | undefined = [...best.children].find(
      (child): child is HTMLElement =>
        child instanceof HTMLElement && has(child)
    );
    if (!deeper) break;
    best = deeper;
  }
  if (!best) return null;
  const target = best;
  target.scrollIntoView?.({ block: 'center' });
  target.classList.add('todo-passage-flash');
  window.setTimeout(() => target.classList.remove('todo-passage-flash'), 2400);
  return target;
}
